import { useAction, useAtom } from "@reatom/npm-react";
import { ProductDetailResponseDto } from "definitions/product-storage";
import { useEffect } from "react";
import { getActiveLimiterRequest } from "src/store/fetchers";

import { getProductDetailFromStoragePage } from "../store/fetchers/getProductDetailWithPrice";

interface UseProductDetailReturn {
  product: ProductDetailResponseDto | null;
  isLoading: boolean;
  hasSubscribe: boolean;
}

export const useProductDetail = (spuId: number): UseProductDetailReturn => {
  const [activeLimiter] = useAtom(getActiveLimiterRequest.dataAtom);

  const [product, setProduct] = useAtom(
    getProductDetailFromStoragePage.dataAtom,
  );
  const [isLoading] = useAtom(getProductDetailFromStoragePage.isLoadingAtom);
  const loadProductDetail = useAction(getProductDetailFromStoragePage);
  const hasSubscribe = (activeLimiter?.length ?? 0) > 0;

  useEffect(() => {
    if (!spuId || !hasSubscribe) {
      return;
    }

    loadProductDetail(spuId);

    return () => {
      setProduct(null);
    };
  }, [hasSubscribe, loadProductDetail, setProduct, spuId]);

  return {
    product,
    isLoading,
    hasSubscribe,
  };
};
